export default __webpack_public_path__ + "static/media/Flag_of_Monaco.73fccacc.svg";